import { Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'

const HOLD_TIMES = [0, 5, 10, 15, 30, 45]

interface Props extends Omit<SelectProps<number>, 'items'> {
  onChange?: (value: number) => void
}
const HoldTimeSelect = (props: Props) => {
  const { onChange, ...otherProps } = props
  const { t } = useTranslation()
  const items = HOLD_TIMES.map((value) => ({
    value,
    title: value === 0 ? t('No hold time') : t('{{count}} minutes', { count: value }),
  }))
  return <Select items={items} onSelect={onChange} testID="HoldTimeSelect.Container" {...otherProps} />
}

export default HoldTimeSelect
